<template lang="pug">
  #home
    Header
    v-container(fluid)
      v-layout(row wrap)
        v-flex.list.px-2(xs12 sm6)
          List
        v-flex.pa-3(xs12 sm6)
          v-layout(row wrap d-flex text-xs-center)
            a(@click="downloadImage").link Descargar como imagen

            .link(v-if="userPermissions.updateReports")
              a(@click="setEditForm") Editar información
          Postal(v-if="record.folio === null")
          v-carousel(:cycle="false" v-if="record.folio !== null")
            v-carousel-item(v-for="(item,i) in images" :src="item.url + '?' + new Date().getTime()" :key="i")
          v-layout.mt-10.container.postal-container.pa-0
            v-btn.px-2.bold.main-color-button(to="/statistics") Estadísticas
          v-layout.mt-10.container.reference-container.pa-0
            p Si tienes duda en como registrar los datos para la atención de asesorías y casos, 
              | no te olvides de revisar el 
              a(href="/static/documents/Atencion_Ax1_Atencion_Procedimiento_210727.pdf" target="_blank") procedimiento general 
              | y los procedimiento específicos. 
              | Si las dudas persisten, comunicar al responsable de documentación.

</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import List from "@/components/List/List.vue";
import Postal from "@/components/Postal/Postal.vue";

export default {
  name: "home",
  components: {
    Header,
    List,
    Postal
  },
  data() {
    return {
      user: this.$store.state.user
    };
  },
  computed: {
    userPermissions(){
      return this.$store.getters.user.permission;
    },
    record() {
      return this.$store.state.record;
    },
    images() {
      return this.$store.state.carousel;
    }
  },
  methods: {
    downloadImage() {
      if (
        this.record["_id"] === "" ||
        typeof this.record["_id"] === "undefined"
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "No has seleccionado un folio"
        });
      } else {
        let jumbotron = document.querySelectorAll(".carousel .jumbotron");
        let imageURL = "";

        jumbotron.forEach(node => {
          if (node.getAttribute("style") !== "height: 100%; display: none;") {
            imageURL = node.querySelector(".jumbotron__wrapper .jumbotron__image").getAttribute("src");
          }
        });

        let link = document.createElement("a");
        link.download = 'frayjuandelarios-folio' + this.record.folio + ".jpeg";
        link.href = imageURL;
        link.click();
      }
    },
    setEditForm() {
      if (
        this.record["_id"] === "" ||
        typeof this.record["_id"] === "undefined"
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "No has seleccionado un folio"
        });
      } else {
        this.$store.commit('showVictimForm', false);
        this.$store.commit("setEditionState", true);
        this.$router.replace("/form");
      }
    }
  },
  watch: {
    record() {
      if (this.record.folio !== null) {
        let postalImages = [];
        postalImages.push(this.record.postal);
        _.forEach(this.record.victims, (p) => {
          postalImages.push(p.postal);
        });
        this.$store.commit("updateCarouselImages", postalImages);
      }
    }
  },
  created() {
    this.$store.commit("updateAttentionRelation", false);
  }
};
</script>
<style lang="scss" scoped>
.link {
  color: #4a4a4a !important;
}
.mt-10 {
  margin-top: 40px !important;
}
.main-color-button {
  height: 61px;
  border-radius: 8px;
  margin: 0px;
}
.home-border {
  min-width: 600px;
}
.carousel {
  margin: 15px 75px;
  width: 77%;
  & /deep/.jumbotron__wrapper .jumbotron__image {
    height: 100% !important;
    min-height: 100%;
    width: 100%;
    min-width: 100%;
    object-fit: contain !important;
  }
}
.reference-container {
  max-width: 35em;
  p {
    font-size: 12px;
  }
  a {
    font-size: 12px;
    color: #ca0588 !important;
  }
}
</style>
